import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { SearchContext } from "@context/SearchContext";
import MovieSessionSelector from "@components/V3/MovieDetails/MovieSessionSelector";
import MovieTitleCard from "@components/V3/MovieDetails/MovieTitleCard";

const MovieDetailsBase = () => {
    const { id, movieName } = useParams();
    const { fetchMovie } = useContext(SearchContext);

    useEffect(() => {
        if (id && movieName) {
            fetchMovie(id, movieName);
        }
    }, [id, movieName]);

    return (
        <>
            <MovieTitleCard />
            <MovieSessionSelector />
        </>
    );
};

export default MovieDetailsBase;
